import React, { useContext } from "react";
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import config from 'config';
import Maps from "../components/Maps/Maps.jsx"
import StreetViewMap from "components/Maps/StreetViewMap.jsx";
import Styles from "styles/mapsView.module.css";
import GlobalContext from "context/globalContext";

function MapsView(props) {
  const globalContext = useContext(GlobalContext);
  
  if (!globalContext.job.response.details) {
    return (
      <div>Loading..</div>
    )
  }
  return (
    <div className={"content " + Styles.mapContent}>
      <Grid fluid>
        <Row>
          <Col md={6}>
            <Card
              title="Street View"
              content={
                
                <StreetViewMap apiKey={config.googleMapApi}
                  longitude={globalContext.job.response.details.longitude}
                  latitude={globalContext.job.response.details.latitude}
                />
              }
            />
          </Col>
          <Col md={6}>
            <Card
              title="Map View"
              content={
                <Maps apiKey={config.googleMapApi}
                  longitude={globalContext.job.response.details.longitude}
                  latitude={globalContext.job.response.details.latitude}
                  clientLocation={globalContext.customer.response}
                />
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

export default MapsView;
